import { Box, Grid, IconButton, useMediaQuery, useTheme } from "@mui/material";
import React, { FC, useEffect, useState } from "react";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";

import { useActions } from "../../../hooks/useActions";
import { useTypedSelector } from "../../../hooks/useTypedSelector";

import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";

import "./styles.css"

const TeamCarousel = () => {
    const { palette } = useTheme();
    const theme = useTheme();

    const isXl = useMediaQuery(theme.breakpoints.only("xl"));
    const isLg = useMediaQuery(theme.breakpoints.only("lg"));
    const isMd = useMediaQuery(theme.breakpoints.only("md"));
    const isXs = useMediaQuery(theme.breakpoints.down("md"));

    const [team, setTeam] = useState<Array<string>>([
    ]);

    useEffect(() => {
        let tempArr: Array<string> = [];
        for (let i = 0; i < 14; i++) {
            if (isMd)
                tempArr.push(`/assets/backgrounds/team_tablet/${i + 1}.png`);
            else if (isXs)
                tempArr.push(`/assets/backgrounds/team_phone/${i + 1}.png`);
            else
                tempArr.push(`/assets/backgrounds/team_desktop/${i + 1}.png`);
        }
        setTeam(tempArr)
    }, [isMd])


    return (
        <>
            {(isXl || isLg) && <Box sx={{ height: "fit-content", position: "relative" }}>
                <Swiper
                    modules={[Navigation]}
                    navigation={{
                        nextEl: '.team-next',
                        prevEl: '.team-prev'
                    }}
                    loop={true}
                    slidesPerView={4}
                    slidesPerGroup={1}
                    spaceBetween={30}
                    style={{ paddingLeft: "30px", paddingRight: "30px" }}
                >
                    {team.map((item, index) => {
                        return (
                            <SwiperSlide key={`partner_${index}`}>
                                <img
                                    loading="lazy"
                                    src={item}
                                    alt={`team_${index}`}
                                    style={{ width: "264px", height: "349px" }}
                                />
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
                <Box sx={{ width: "100%", position: "absolute", left: "0px", top: "45%", display: "flex", justifyContent: "space-between" }}>
                    <Box className="team-prev">
                        <IconButton disableRipple size="small" sx={{ border: `1px solid ${palette.text.secondary}`, p: "0px", zIndex: 10 }}>
                            <KeyboardArrowLeft fontSize="inherit" sx={{ color: palette.text.secondary }} />
                        </IconButton>
                    </Box>
                    <Box className="team-next">
                        <IconButton disableRipple size="small" sx={{ border: `1px solid ${palette.text.secondary}`, p: "0px", zIndex: 10 }}>
                            <KeyboardArrowRight fontSize="inherit" sx={{ color: palette.text.secondary }} />
                        </IconButton>
                    </Box>
                </Box>
            </Box>}
            {isMd && <Box sx={{ height: "fit-content", position: "relative" }}>
                <Swiper
                    modules={[Navigation]}
                    navigation={{
                        nextEl: '.team-next',
                        prevEl: '.team-prev'
                    }}
                    loop={true}
                    slidesPerView={2}
                    slidesPerGroup={1}
                    spaceBetween={10}
                    style={{ marginLeft: "43px", marginRight: "43px", paddingLeft: "0px", paddingRight: "0px" }}
                >
                    {team.map((item, index) => {
                        return (
                            <SwiperSlide key={`partner_${index}`}>
                                <Box sx={{ width: "324px", height: "441px" }}>
                                    <img
                                        loading="lazy"
                                        src={item}
                                        alt={`team_${index}`}
                                        style={{ width: "inherit", height: "inherit" }}
                                    />
                                </Box>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
                <Box sx={{ width: "100%", position: "absolute", left: "0px", top: "45%", display: "flex", justifyContent: "space-between" }}>
                    <Box className="team-prev">
                        <IconButton disableRipple size="small" sx={{ width: "40px", height: "40px", border: `2px solid ${palette.text.secondary}`, p: "0px", zIndex: 10 }}>
                            <KeyboardArrowLeft fontSize="inherit" sx={{ width: "inherit", height: "inherit", color: palette.text.secondary }} />
                        </IconButton>
                    </Box>
                    <Box className="team-next">
                        <IconButton disableRipple size="small" sx={{ width: "40px", height: "40px", border: `2px solid ${palette.text.secondary}`, p: "0px", zIndex: 10 }}>
                            <KeyboardArrowRight fontSize="inherit" sx={{ width: "inherit", height: "inherit", color: palette.text.secondary }} />
                        </IconButton>
                    </Box>
                </Box>
            </Box>}
            {isXs && <Box sx={{ height: "fit-content", position: "relative" }}>
                <Swiper
                    modules={[Navigation]}
                    navigation={{
                        nextEl: '.team-next',
                        prevEl: '.team-prev'
                    }}
                    loop={true}
                    slidesPerView={1}
                    slidesPerGroup={1}
                    spaceBetween={15}
                    style={{ marginLeft: "35px", marginRight: "0px", paddingLeft: "0px", paddingRight: "43px" }}
                >
                    {team.map((item, index) => {
                        return (
                            <SwiperSlide key={`partner_${index}`} className="slide">
                                <Box sx={{ width: "264px", height: "349px" }}>
                                    <img
                                        loading="lazy"
                                        src={item}
                                        alt={`team_${index}`}
                                        style={{ width: "inherit", height: "inherit" }}
                                    />
                                </Box>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
                <div className="gradient-overlay"></div>
                <Box sx={{ width: "100%", position: "absolute", left: "0px", top: "47%", display: "flex", justifyContent: "space-between", zIndex: 101 }}>
                    <Box className="team-prev">
                        <IconButton disableRipple size="small" sx={{ width: "24px", height: "24px", border: `2px solid ${palette.text.secondary}`, p: "0px", zIndex: 10 }}>
                            <KeyboardArrowLeft fontSize="inherit" sx={{ width: "inherit", height: "inherit", color: palette.text.secondary }} />
                        </IconButton>
                    </Box>
                    <Box className="team-next">
                        <IconButton disableRipple size="small" sx={{ width: "24px", height: "24px", border: `2px solid ${palette.text.secondary}`, p: "0px", zIndex: 10 }}>
                            <KeyboardArrowRight fontSize="inherit" sx={{ width: "inherit", height: "inherit", color: palette.text.secondary }} />
                        </IconButton>
                    </Box>
                </Box>
            </Box>}
        </>
    );
};

export default TeamCarousel;
